exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n\r\n/* created by AHMED HAYEL */\r\n\r\n#showtime{\r\n    text-align: center;\r\n    margin-top:20%;\r\n}\r\n.error{\r\nfont-weight: bold;\r\ncolor: lightyellow;\r\nfont-size:100px;\r\nline-height: 100px;\r\n\r\n}\r\n.hyber{\r\n    color:white;\r\n    font-size:16px;\r\n    cursor: pointer;\r\n    text-decoration: underline;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/error/error.component.css
// module id = 317
// module chunks = 1